// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const { requestInsuranceCurrentState } = require('./insuranceRequestState');

// @ constants
const { THIRD_STEP } = require('constants/index');
const {
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_REQUEST,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_FAILURE,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
    INSURANCE_REQUEST_CANCEL_SIMULATION_REQUEST,
    INSURANCE_REQUEST_CANCEL_SIMULATION_SUCCESS,
    INSURANCE_REQUEST_CANCEL_SIMULATION_FAILURE,
    INSURANCE_REQUEST_SELECT_BASIC_PLAN,
} = require('../../insuranceConstants/actionTypes');
const {
    PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL,
    STANDALONE_RELATED_INSURANCE
} = require('constants/flagBasedFeatures');

const linkClientInProgress = () => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_REQUEST
});

const linkClientSuccess = id => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    data: { id }
});

const linkClientFailure = error => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_FAILURE,
    data: { error }
});

const linkClientSuccessInitialState = () => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
});

const cancelSimulationInProgress = () => ({
    type: INSURANCE_REQUEST_CANCEL_SIMULATION_REQUEST
});

const cancelSimulationSuccess = id => ({
    type: INSURANCE_REQUEST_CANCEL_SIMULATION_SUCCESS,
    data: { id }
});

const cancelSimulationFailure = error => ({
    type: INSURANCE_REQUEST_CANCEL_SIMULATION_FAILURE,
    data: { error }
});

const basicPlanAcceptanceModal = () => ({
    type: INSURANCE_REQUEST_SELECT_BASIC_PLAN,
});

const linkClient = token => (dispatch, getState) => {
    const currentState = getState().insuranceRequestSimulation;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isEnabledFF = immFlagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
    const contractNumber = getState().insuranceChosenMortgage.getIn(['chosenMortgage', 'contractNumber']);

    if (!currentState.get('isFetching')) {
        dispatch(linkClientInProgress());

        let  params = {
            'simulationToken': token
        }

        if(isEnabledFF && contractNumber !== undefined) {
            params = {
                'simulationToken': token,
                'mortgageContractNumber': contractNumber
            }
        }

        const requestData = {
            query: params
        };

        if (immFlagBasedFeatures.get(PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL)) {
            if (__CONTACT_CENTER__) {
                requestData['header'] = {
                    version: '3',
                }
            } else {
                requestData['header'] = {
                    version: '2',
                }
            }
        }

        return APIPost(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestSimulationLinkClient'),
            requestData
        )
            .then(response => {
                dispatch(linkClientSuccess(response.data));
                requestInsuranceCurrentState()(dispatch, getState);
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(linkClientFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const cancelSimulation = (simulationToken, step) => (dispatch, getState) => {
    const cancelInProgress = step === THIRD_STEP ? getState().insuranceRequestWizard.getIn(['steps', step, 'cancelInProgress']) : false;
    if (!cancelInProgress) {
        dispatch(cancelSimulationInProgress());
        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestCancelQuotation'
        })
            .then(() => {
                dispatch(cancelSimulationSuccess());

                if (simulationToken) {
                    dispatch(linkClient(simulationToken));
                } else {
                    dispatch(requestInsuranceCurrentState());
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(cancelSimulationFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    basicPlanAcceptanceModal,
    cancelSimulation,
    linkClient,
    linkClientSuccessInitialState,
};
